"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logInfo = exports.consoleError = void 0;
const consoleError = (eventName, ext1, ext2, ext3) => {
    const reportData = JSON.stringify({
        name: eventName,
        ext1,
        ext2,
        ext3,
    });
    console.error(reportData);
};
exports.consoleError = consoleError;
const logInfo = (errEventName, ext1, ext2, ext3) => {
    (0, exports.consoleError)(errEventName, ext1, ext2, ext3);
};
exports.logInfo = logInfo;
//# sourceMappingURL=logger.js.map